import React, { PureComponent } from 'react';
import { ArrowBackRounded as ArrowBackIcon } from '@mui/icons-material';
import Table from '@mui/material/Table/Table';
import TableHead from '@mui/material/TableHead/TableHead';
import TableRow from '@mui/material/TableRow/TableRow';
import TableCell from '@mui/material/TableCell/TableCell';
import TableBody from '@mui/material/TableBody/TableBody';
import { styled } from '@mui/system';
import * as dates from '@simplybenefits/sb-dates';
import PricingDesignForm from './PricingDesignForm.js';
import * as Theme from '../../theme/index.js';
import MessageCard from '../../components/Cards/MessageCard.js';
import Bubble from '../../components/Bubble.js';
import Button from '../../components/Button.js';
import Text from '../../components/Text.js';
const StyledTableRow = styled(TableRow)(({
  theme
}) => ({
  backgroundColor: theme.palette.primary.main
}));
class Revisions extends PureComponent {
  state = {
    revisions: [],
    selectedRevision: null
  };
  async componentDidMount() {
    const revisions = await this.props.getPricingRevisions(this.props.selectedDesignID);
    this.setState({
      revisions
    });
  }
  _selectRevision = async revisionID => {
    const selectedRevision = await this.props.getSinglePricingRevision(revisionID);
    this.setState({
      selectedRevision: selectedRevision
    });
  };
  _handleGoBack = () => {
    if (this.state.selectedRevision) {
      this.setState({
        selectedRevision: null
      });
      return null;
    }
    return this.props.goBack();
  };
  render() {
    const {
      selectedClassID,
      selectedDesignID,
      accountID,
      commissions,
      designs
    } = this.props;
    const styles = {
      container: Theme.globalStyles.containerControlSite,
      content: Theme.globalStyles.content,
      contentBlock: Theme.globalStyles.contentBlock,
      tabRoot: Theme.globalStyles.tabRoot,
      tabSelected: Theme.globalStyles.tabSelected,
      tabsIndicator: Theme.globalStyles.tabsIndicator,
      saveBtn: {
        display: 'block',
        marginLeft: 'auto',
        marginTop: "20px !important"
      },
      header: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between"
      },
      headerTitleBlock: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
      },
      backBtn: {
        minWidth: "30px",
        padding: "2px",
        marginRight: "5px",
        marginLeft: "-5px"
      },
      table: {
        ...Theme.globalStyles.table,
        border: "2px solid #F1F1F1",
        backgroundColor: '#FFF'
      },
      scrollbar: Theme.globalStyles.scrollbar,
      tableHeading: {
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingRight: "2vw",
        paddingLeft: "2vw",
        fontFamily: Theme.fonts.type.heading,
        color: Theme.colors.surface,
        whiteSpace: "nowrap",
        border: "none"
      },
      tableCell: {
        paddingTop: "10px",
        paddingBottom: "10px",
        fontFamily: Theme.fonts.type.light,
        whiteSpace: "nowrap",
        paddingRight: "2vw",
        paddingLeft: "2vw",
        color: Theme.colors.mainTextGrey
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      style: styles.contentBlock
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.header
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.headerTitleBlock
    }, /*#__PURE__*/React.createElement(Button, {
      customStyle: styles.backBtn,
      onClick: this._handleGoBack,
      transparent: true
    }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0"
    }, "Revisions")), /*#__PURE__*/React.createElement(Bubble, {
      label: designs[selectedClassID][selectedDesignID].title,
      isSelected: true,
      clickable: false
    })), this.state.selectedRevision ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MessageCard, {
      title: `Revision Review (${this.state.selectedRevision.id})`,
      subtitle: `You have loaded a past revision for the selected pricing. Changes made by: ${this.state.selectedRevision.changedBy.name} on ${dates.getLocalDisplay(this.state.selectedRevision.timestamp, 'lll')}. Pricing changes are disabled while in the revision view.`
    }), /*#__PURE__*/React.createElement(PricingDesignForm, {
      classID: selectedClassID,
      designID: selectedDesignID,
      designs: designs,
      accountID: accountID,
      commissions: commissions,
      pricing: this.state.selectedRevision,
      revision: true,
      loader: this.props.loader
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, !this.state.revisions || this.state.revisions.length === 0 ? /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, "You haven't saved any changes to the current plan design. All plan design revisions will show up here where you can view and revert to past versions.") : /*#__PURE__*/React.createElement("div", {
      style: {
        overflow: "auto",
        maxHeight: 600,
        ...styles.scrollbar
      }
    }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(StyledTableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      style: styles.tableHeading
    }, "Revision ID"), /*#__PURE__*/React.createElement(TableCell, {
      style: styles.tableHeading
    }, "Design"), /*#__PURE__*/React.createElement(TableCell, {
      style: styles.tableHeading
    }, "Change By"), /*#__PURE__*/React.createElement(TableCell, {
      style: styles.tableHeading
    }, "Date of Change"), /*#__PURE__*/React.createElement(TableCell, {
      style: styles.tableHeading
    }))), /*#__PURE__*/React.createElement(TableBody, null, this.state.revisions.map((revision, index) => {
      let backgroundObject = {
        border: "none"
      };
      if (index % 2 !== 0) {
        backgroundObject = {
          backgroundColor: Theme.colors.backgroundGrey,
          border: "none"
        };
      }
      return /*#__PURE__*/React.createElement(TableRow, {
        key: revision.revisionID
      }, /*#__PURE__*/React.createElement(TableCell, {
        style: {
          ...styles.tableCell,
          ...backgroundObject
        }
      }, revision.revisionID), /*#__PURE__*/React.createElement(TableCell, {
        style: {
          ...styles.tableCell,
          ...backgroundObject
        }
      }, revision.title), /*#__PURE__*/React.createElement(TableCell, {
        style: {
          ...styles.tableCell,
          ...backgroundObject
        }
      }, `${revision.changedByName} (${revision.changedByType})`), /*#__PURE__*/React.createElement(TableCell, {
        style: {
          ...styles.tableCell,
          ...backgroundObject
        }
      }, dates.getLocalDisplay(revision.effectiveDate, 'lll')), /*#__PURE__*/React.createElement(TableCell, {
        style: {
          ...styles.tableCell,
          ...backgroundObject
        }
      }, /*#__PURE__*/React.createElement(Button, {
        transparent: true,
        onClick: () => {
          this._selectRevision(revision.revisionID);
        }
      }, "View")));
    }))))));
  }
}
export default Revisions;